import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import _ from "lodash";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class ActionComponent extends Component {
  openRemoveFieldCategoryModal = () => {
    const {
      openRemoveFieldCategoryModal
    } = this.props.metadata.customComponentMetadata;
    const item = this.props.rowData;
    openRemoveFieldCategoryModal(item.uid);
  };

  openEditFieldCategoryModal = () => {
    const {
      openEditFieldCategoryModal
    } = this.props.metadata.customComponentMetadata;
    const item = this.props.rowData;
    openEditFieldCategoryModal(item.placeholder);
  };

  render() {
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.openEditFieldCategoryModal}>edytuj</a>
              <br />
              <a onTouchTap={this.openRemoveFieldCategoryModal}>usuń</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired,
    fieldCategories: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onRowClick = (row, e) => {
    if (
      e.target.nodeName !== "INPUT" &&
      row.props.data.placeholder &&
      e.target.className !== "icon-table link" &&
      e.target.className !== "checkbox-in-table-label"
    ) {
      const { history } = this.props;
      history.pushState(
        "/fieldCategories/:placeholder",
        `/fieldCategories/${row.props.data.placeholder}`,
        {}
      );
    }
  };

  openRemoveFieldCategoryModal = uid => {
    const { actions } = this.props;
    actions.setIsRemoveFieldCategoryModalVisible(uid);
  };

  closeRemoveFieldCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveFieldCategoryModalVisible(false);
  };

  removeFieldCategory = () => {
    const {
      actions,
      notificationSystem,
      fieldCategories: {
        fieldCategories: { isRemoveModalVisible, meta: fieldCategoriesMeta }
      }
    } = this.props;
    actions
      .removeFieldCategory(isRemoveModalVisible)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          let notification = {
            level: "success",
            message: "Usunięto kategorię!",
            position: "br",
            autoDismiss: 5,
            dismissible: true
          };
          notificationSystem.addNotification(notification);
          actions
            .getFieldCategories(fieldCategoriesMeta)
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
        }
      });
    this.closeRemoveFieldCategoryModal();
  };

  openEditFieldCategoryModal = placeholder => {
    const { actions } = this.props;
    actions.setIsEditFieldCategoryModalVisible(placeholder);
  };

  closeEditFieldCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsEditFieldCategoryModalVisible(false);
  };

  editFieldCategory = () => {
    const {
      actions,
      notificationSystem,
      fieldCategories: {
        fieldCategories: {
          isEditModalVisible,
          meta: fieldCategoriesMeta,
          entities: fieldCategories
        }
      }
    } = this.props;

    actions
      .updateFieldCategory(
        fieldCategories.get(isEditModalVisible).toJS(),
        fieldCategories.getIn([isEditModalVisible, "uid"])
      )
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions
            .getFieldCategories(fieldCategoriesMeta)
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
        }
      });

    this.closeEditFieldCategoryModal();
  };

  render() {
    const {
      fieldCategories,
      fieldCategories: {
        fieldCategories: { isRemoveModalVisible, isEditModalVisible, loading }
      },
      actions,
      tableWidth,
      tableHeight
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "placeholder",
        displayName: "Nazwa kategorii",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemoveFieldCategoryModal: this.openRemoveFieldCategoryModal,
          openEditFieldCategoryModal: this.openEditFieldCategoryModal
        }
      }
    ];

    let data = [];
    let index = 0;

    fieldCategories
      .getIn(["fieldCategories", "entities"])
      .forEach(function(item) {
        index++;
        data.push({
          ...item.toJS(),
          index:
            index +
            fieldCategories.getIn(["fieldCategories", "meta", "currentPage"]) *
              fieldCategories.getIn(["fieldCategories", "meta", "limit"])
        });
      });

    const editFieldCategoryProps = {
      actions: actions,
      entity: fieldCategories.getIn([
        "fieldCategories",
        "entities",
        isEditModalVisible
      ]),
      feature: "fieldCategories",
      uid: isEditModalVisible
    };

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={["index", "placeholder", "actions"]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          noDataMessage={loading ? "" : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />

        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveFieldCategoryModal}
            enterAction={this.removeFieldCategory}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <div className="col-xs-12">
                <p>Czy napewno usunąć?</p>
                <button className="error" onClick={this.removeFieldCategory}>
                  Usuń
                </button>
              </div>
            </div>
          </Modal>
        )}

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditFieldCategoryModal}
            enterAction={this.editFieldCategory}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Edytuj pole</h3>
              <div className="col-xs-12">
                <InputCustom
                  placeholder="Nazwa kategorii"
                  field={["placeholder"]}
                  {...editFieldCategoryProps}
                />
              </div>
              <div className="col-xs-12">
                <button className="info" onClick={this.editFieldCategory}>
                  Aktualizuj opis
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/fieldCategories/table.react.js